export const CONTENT_TYPE = {
  Article: 'Artikkeli',
  Overview: 'Katsaus',
  CaseCommentary: 'Oikeustapauskommentti',
  ShortLegalNews: 'Juridiikkaa lyhyesti',
  LegalNews: 'Uutinen',
} as const;

export type ContentType = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

// Content types that are considered article content types (i.e. they are displayed in article cards)
export const ARTICLE_CONTENT_TYPES = [
  CONTENT_TYPE.Article,
  CONTENT_TYPE.CaseCommentary,
  CONTENT_TYPE.Overview,
  CONTENT_TYPE.ShortLegalNews,
];
